import graphql__5210d48173b99462b183 from "./__generated__/VideoPlayer_withVideoStream.graphql.js";import { useEffect, useState, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import ReactPlayer from "react-player/file";

import { loadScriptOnce } from "../Utils/loadScriptOnce";
import ResponsiveImage from "../Utils/ResponsiveImage";

const VideoPlayer = ({ controls = true, ...props }) => {
  const {
    hlsLibUrl,
    hlsUrl,
    width = "100%",
    height = "100%",
    cover
  } = useFragment(VideoPlayer_withVideoStream, props.withVideoStream);

  const [isHlsLibLoaded, setHlsLibLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => loadScriptOnce(hlsLibUrl, () => setHlsLibLoaded(true)), [hlsLibUrl]);

  // Force the cover preview to take the full container width and let its height adapt to
  // the image's own aspect ratio, instead of being cropped to the configured player size.
  const light = useMemo(() => {
    if (!cover) return false;

    return <ResponsiveImage image={cover} style={{ width: "100%", height: "auto" }} />;
  }, [cover]);

  if (!isHlsLibLoaded) return null;

  return (
    <ReactPlayer
      url={hlsUrl}
      controls={controls}
      width={width}
      height={height}
      light={light}
      playing={isPlaying}
      onClickPreview={() => setIsPlaying(true)}
    />
  );
};

const VideoPlayer_withVideoStream = graphql__5210d48173b99462b183;

export default VideoPlayer;
